import { createFileRoute } from "@tanstack/react-router"

// Compatibility child only. The parent redirects old deep links to /admin/ad-library?adId=….
export const Route = createFileRoute("/ad-library/$adId")({
  component: () => null,
})
